// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#pdf-viewer {
  height: calc(100% - 1px);
}

#pdf {
  height: 100%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./core/components/quizzes/QuizPDFViewer.css"],"names":[],"mappings":"AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":["@import \"../shared.css\";\r\n\r\n\r\n#pdf-viewer {\r\n  height: calc(100% - 1px);\r\n}\r\n\r\n#pdf {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
